// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3997) return "static/chunks/3997-e6018a2b9f27d361.js";
	if (chunkId === 2830) return "static/chunks/2830-a3356b75e91d9222.js";
	if (chunkId === 8972) return "static/chunks/8972-94d0a88845fb7982.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"22":"b83f977e003ea0f7","8411":"d5ad6f2b2d8a151e","8832":"98641bc9fa54214f"}[chunkId] + ".js";
};